<template>
  <div>
    <div class="statistics">

      <h3 class="view__title--sub">{{ L.localize("Campaigns_24hPerformance") }}</h3>
      <div class="statistics__zone">
        <line-chart :chartData="performanceData" :options="performanceOptions" class="statistics__chart--fullWidth"></line-chart>
      </div>

      <h3 class="view__title--sub">{{ L.localize("Campaigns_TopLinks") }}</h3>
      <div class="statistics__zone">
        <ul class="statistics__list">
          <li class="statistics__entry" v-for="link in links" :key="link.url">
            <a class="link" :href="link.url" target="_blank">{{ link.text || link.url }}</a>
            <span class="statistics__list__value">{{ link.clicksCount }}</span>
          </li>
        </ul>
      </div>

      <h3 class="view__title--sub">{{ L.localize("Campaigns_Performance") }}</h3>
      <div class="statistics__zone">
        <ProgressBar label="Campaigns_OpenRate" :max="report.sentCount" :percent="report.opensCount" />
        <ProgressBar label="Campaigns_DeliveryRate" :max="report.sentCount" :percent="report.deliveriesCount" :doNotExceedMax="true" />
        <ProgressBar label="Campaigns_ClickOpen" :max="report.opensCount" :percent="report.clicksCount" />
        <ProgressBar label="Campaigns_UnsubscribeRate" :max="report.sentCount" :percent="report.unsubscribeCount" />
        <ProgressBar label="Campaigns_BounceRate" :max="report.sentCount" :percent="report.bouncesCount" />
        <ProgressBar label="Campaigns_ComplaintRate" :max="report.sentCount" :percent="report.complaintsCount" />
      </div>

      <h3 class="view__title--sub">{{ L.localize("Campaigns_Preview") }}</h3>
      <article class="preview">
        <div class="preview__content" v-html="campaign.body" />
      </article>
    </div>
  </div>
</template>

<script>
import { ProgressBar } from 'components/partials'
import Grid from 'components/layout/grid'
import { LineChart } from 'components/charts'
import { mapGetters } from 'vuex'
import L from 'services/Localization'
import Format from 'services/Format'

export default {
  name: 'campaign-success',
  components: { LineChart, Grid, ProgressBar },
  props: {
    campaign: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      L: L
    }
  },
  computed: {
    ...mapGetters({
      links: 'allLinks',
      report: 'campaignReport',
      clicks: 'allClicks',
      opens: 'allOpens'
    }),
    performanceData() {
      var labels = this.clicks.map(click => Format.date(Format.dateFromEpoch(click.timestamp), 'hh:mm'))
      var clicks = this.clicks.map(click => click.count)
      var opens = this.opens.map(open => open.count)
      return {
        labels: labels,
        datasets: [
          {
            label: L.localize('Campaigns_Clicks'),
            backgroundColor: '#00aeef',
            borderColor: '#00aeef',
            fill: false,
            data: clicks
          },
          {
            label: L.localize('Campaigns_Opens'),
            backgroundColor: '#a3d39c',
            borderColor: '#a3d39c',
            fill: false,
            data: opens
          }
        ]
      }
    },
    performanceOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  created() {
    let request = { id: this.campaign.id, startTime: this.campaign.sentAt }
    this.$store.dispatch('getReport', this.campaign.id)
    this.$store.dispatch('getLinks', this.campaign.id)
    this.$store.dispatch('getClicks', request)
    this.$store.dispatch('getOpens', request)
  }
}
</script>

<style lang='scss'>

</style>



// WEBPACK FOOTER //
// CampaignSuccess.vue?642e8c2d